export enum TipoCupom {
    "ITEM" = "ITEM",
    "ITEM_DESCONTO_PROGRESSIVO" = "ITEM_DESCONTO_PROGRESSIVO",
    "TAXA_ENTREGA" = "TAXA_ENTREGA",
    "TOTAL" = "TOTAL",
    "PORCENTAGEM" = "PORCENTAGEM",
    "PORCENTAGEM_PRODUTOS" = "PORCENTAGEM_PRODUTOS"
}

export enum TipoCupomDescricao {
    "ITEM" = "Item",
    "ITEM_DESCONTO_PROGRESSIVO" = "Item progressivo",
    "TAXA_ENTREGA" = "Desconto total da taxa de entrega",
    "TOTAL" = "Abatido do valor total",
    "PORCENTAGEM" = "Porcentagem",
    "PORCENTAGEM_PRODUTOS" = "Porcentagem produtos"
}